import { CONSULT_SURVEY, CONTACT_URL } from '../data/url';
import img_line from '../assets/img_line.svg';

import './FloatingButton.css';

export const ConsultButton = () => {
    return (
        <div className='consult_button'>
            <a href={CONSULT_SURVEY} target='_blank' rel='nooperer noreferrer'>
                洽詢企業方案
            </a>
        </div>
    );
};

export const ContactButton = () => {
    return (
        <div className='contact_button'>
            <a href={CONTACT_URL} target='_blank' rel='nooperer noreferrer'>
                <img src={img_line} alt='img_line'/>
                聯絡我們
            </a>
        </div>
    );
};
